/**
 * Format warranty into years/months in the specific way Jason wanted
 * @param {int} warrantyInMonths
 * @returns
 */
export default function (warrantyInMonths, apostropheString = "'") {
    if (warrantyInMonths == null || warrantyInMonths <= 0) {
        return false;
    }

    if (warrantyInMonths < 12) {
        if (warrantyInMonths == 1) {
            return '1 Month';
        }

        return warrantyInMonths + ' Months' + apostropheString;
    }

    let years = Math.floor(warrantyInMonths / 12);
    let months = warrantyInMonths - (years * 12);

    if (years == 1) {
        years = '1 Year';
        if (months == 0) {
            return '12 Months' + apostropheString;
        }
    } else {
        years = years + ' Years';
    }

    if (months == 0) {
        return years + apostropheString;
    }

    if (months == 1) {
        return years + ' 1 Month';
    }

    return years + ' ' + months + ' Months' + apostropheString;
}